<template>
  <div class="fc-notification-toggle-row" :data-testid="dataTestid">
    <div>
      <div class="fc-notification-toggle-row__title">{{ title }}</div>
      <div v-if="hint" class="fc-notification-toggle-row__sub">{{ hint }}</div>
    </div>
    <NotificationStatusToggle
      :value="value"
      :disabled="disabled"
      data-testid="notification-enable-row__switch"
      @change="$emit('input', $event)"
    />
  </div>
</template>

<script>
import NotificationStatusToggle from '../NotificationStatusToggle/NotificationStatusToggle.vue';

export default {
  name: 'NotificationEnableRow',
  components: { NotificationStatusToggle },
  props: {
    value: { type: Boolean, default: true },
    title: { type: String, default: 'Enable notification' },
    hint: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    dataTestid: { type: String, default: 'notification-enable-row' },
  },
};
</script>
